import { Row, Col,  message,Skeleton } from 'antd';
import axios from 'axios';
import classes from '../Pages.module.css';
import { useState, useEffect, useContext } from 'react';
import DataContext from '../../../Context/dataContext';
import SalaryTransactionTable from './SalaryTransactionTable';
import SalaryForm from './SalaryForm';

import dayjs from 'dayjs';

const SalaryProcessing = (props) => {
    console.log(props,"props from salary processing");
    const employeeData = useContext(DataContext);
    const [columns, setColumns] = useState([]);
    const [rows, setRows] = useState(null);
    const [ad, setAD] = useState(null);
    const [form, setForm] = useState({
        attend_code: null,
        month: null,
        attend_date: dayjs(new Date()).format('DD/MM/YYYY'),
        department: null,
        emp_type: null,
    });

    useEffect(() => {
        setRows(null);
        setColumns([]);
        setAD(null);
        console.log(form);
        axios
            .get(employeeData.URL + '/api/v1/salary-process/salary-data', {
                withCredentials: true,
            })
            .then((response) => {
                console.log(response);
                setAD((ad) => {
                    let newad = response.data.data;
                    return {
                        ...newad,
                        month: {
                            fields: [{ name: 'KEY' }, { name: 'VALUE' }],
                            rows: [
                                { KEY: '01', VALUE: 'January' },
                                { KEY: '02', VALUE: 'February' },
                                { KEY: '03', VALUE: 'March' },
                                { KEY: '04', VALUE: 'April' },
                                { KEY: '05', VALUE: 'May' },
                                { KEY: '06', VALUE: 'June' },
                                { KEY: '07', VALUE: 'July' },
                                { KEY: '08', VALUE: 'August' },
                                { KEY: '09', VALUE: 'September' },
                                { KEY: '10', VALUE: 'October' },
                                { KEY: '11', VALUE: 'November' },
                                { KEY: '12', VALUE: 'December' },
                            ],
                        },
                    };
                });
            })
            .catch((error) => {
                console.log(error);
            });
    }, []);

    const handleSave = () => {
        if (!form.month) {
            message.error('Please select a month to process salary!');
            return;
        }

        setRows(null);
        setColumns([]);

        axios
            .get(employeeData.URL + '/api/v1/salary-process/salary-calculate', {
                params: {
                    code: form.attend_code || '',
                    empType: form.emp_type || '',
                    dept: form.department || '',
                    month: form.month || '',
                    attend_date: form.attend_date || '',
                },
                withCredentials: true,
            })
            .then((response) => {
                console.log('Salary calculation response:', response);
                if (response.data && response.data.data) {
                    setRows(response.data.data.rows);
                    setColumns(response.data.data.columns);
                }
            })
            .catch((error) => {
                console.log('Error calculating salary:', error);
            });
    };

    return (
        <>
            <Row className={classes['Row']}>
                <Col md={14}>
                    <p className={classes['Title']}>Salary Processing</p>
                </Col>
                <Col className={classes['Col']} md={10}></Col>
                <Col className={classes['Col']} md={24}></Col>
            </Row>

            {form && ad ? (
                <SalaryForm ad={ad} form={form} setForm={setForm} handleSave={handleSave} />
            ) : (
                <>
                    <Skeleton active={true} />
                    <Skeleton active={true} />
                </>
            )}

            <p></p>
            <hr></hr>
            <p></p>

            {ad && rows && columns.length > 0 ? (
                <SalaryTransactionTable ad={ad} data={rows} columns={columns} form={form} />
            ) : (
                <div style={{ textAlign: 'center', marginTop: '20px' }}>
                    <p>No salary data found. Click the "Process" button to calculate salary.</p>
                    {/* <Button type="primary" onClick={handleSave}>
                        Process
                    </Button> */}
                </div>
            )}
        </>
    );
};

export default SalaryProcessing;
